import _regeneratorRuntime from 'babel-runtime/regenerator';
import _Object$assign from 'babel-runtime/core-js/object/assign';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { mapGetters } from 'vuex';
import { fetchDemandStatistic, fetchAssignDemandStatistic } from '@/api/demand/demand';

export default {
  name: 'DashboardStats',
  props: {
    type: String
  },
  data: function data() {
    return {
      loading: true,
      demand: {
        'unsubmit': 0,
        'rejected': 0,
        'submited': 0,
        'confirmed': 0,
        'planned': 0,
        'dev_unassigned': 0,
        'dev_rejected': 0,
        'dev_confirmed': 0,
        'dev_ongoing': 0,
        'test_failed': 0,
        'discarded': 0,
        'delivered': 0
      },
      qa_task: {
        'self_test': 0,
        'submit_fail': 0,
        'auditing': 0,
        'adv_audit_pending': 0,
        'pending': 0,
        'testing': 0,
        'passed': 0,
        'test_failed': 0,
        'published': 0,
        'discarded': 0
      },
      colNum: 10 // 一行显示多少个数据
    };
  },

  computed: _extends({}, mapGetters(['userInfo']), {
    dynamiclink: function dynamiclink() {
      return this.type === 'assigned' ? 'assigned-demand' : 'submitted-demand';
    },
    stats: function stats() {
      return {
        demands: [{
          key: 'unsubmit',
          label: '待提交需求数',
          link: '/butler/' + this.dynamiclink + '/demand?statuses=unsubmit',
          value: this.demand.unsubmit
        }, {
          key: 'rejected',
          label: '已驳回需求数',
          link: '/butler/' + this.dynamiclink + '/demand?statuses=rejected',
          value: this.demand.rejected
        }, {
          key: 'submited',
          label: '已提交/待确认需求数',
          link: '/butler/' + this.dynamiclink + '/demand?statuses=submited',
          value: this.demand.submited
        }, {
          key: 'confirmed',
          label: '已确认需求数',
          link: '/butler/' + this.dynamiclink + '/demand?statuses=confirmed',
          value: this.demand.confirmed
        }, {
          key: 'planned',
          label: '待配置美术资源需求数',
          link: '/butler/' + this.dynamiclink + '/demand?statuses=planned',
          value: this.demand.planned
        }, {
          key: 'dev_unassigned',
          label: '待分配研发需求数',
          link: '/butler/' + this.dynamiclink + '/demand?statuses=dev_unassigned',
          value: this.demand.dev_unassigned
        }, {
          key: 'dev_rejected',
          label: '研发驳回需求数',
          link: '/butler/' + this.dynamiclink + '/demand?statuses=dev_rejected',
          value: this.demand.dev_rejected
        }, {
          key: 'dev_confirmed',
          label: '待研发需求数',
          link: '/butler/' + this.dynamiclink + '/demand?statuses=dev_confirmed',
          value: this.demand.dev_confirmed
        }, {
          key: 'dev_ongoing',
          label: '研发中需求数',
          link: '/butler/' + this.dynamiclink + '/demand?statuses=dev_ongoing',
          value: this.demand.dev_ongoing
        }, {
          key: 'test_failed',
          label: '测试不通过需求数',
          link: '/butler/' + this.dynamiclink + '/demand?statuses=test_failed',
          value: this.demand.test_failed
        }, {
          key: 'discarded',
          label: '已作废需求数',
          link: '/butler/' + this.dynamiclink + '/demand?statuses=discarded',
          value: this.demand.discarded
        }, {
          key: 'delivered',
          label: '已交付需求数',
          link: '/butler/' + this.dynamiclink + '/demand?statuses=delivered',
          value: this.demand.delivered
        }],
        tasks: [{
          key: 'self_test',
          label: '自测任务数',
          link: '/butler/' + this.dynamiclink + '/task?statuses=8',
          value: this.qa_task.self_test
        }, {
          key: 'submit_fail',
          label: '提测失败任务数',
          link: '/butler/' + this.dynamiclink + '/task?statuses=12',
          value: this.qa_task.submit_fail
        }, {
          key: 'auditing',
          label: '待压缩审核任务数',
          link: '/butler/' + this.dynamiclink + '/task?statuses=10',
          value: this.qa_task.auditing
        }, {
          key: 'adv_audit_pending',
          label: '待广告主审核任务数',
          link: '/butler/' + this.dynamiclink + '/task?statuses=13',
          value: this.qa_task.adv_audit_pending
        }, {
          key: 'pending',
          label: '待测试任务数',
          link: '/butler/' + this.dynamiclink + '/task?statuses=7',
          value: this.qa_task.pending
        }, {
          key: 'testing',
          label: '测试中任务数',
          link: '/butler/' + this.dynamiclink + '/task?statuses=1',
          value: this.qa_task.testing
        }, {
          key: 'passed',
          label: '测试通过任务数',
          link: '/butler/' + this.dynamiclink + '/task?statuses=2',
          value: this.qa_task.passed
        }, {
          key: 'test_failed',
          label: '测试不通过任务数',
          link: '/butler/' + this.dynamiclink + '/task?statuses=15',
          value: this.qa_task.test_failed
        }, {
          key: 'discarded',
          label: '已作废任务数',
          link: '/butler/' + this.dynamiclink + '/task?statuses=14',
          value: this.qa_task.discarded
        }, {
          key: 'published',
          label: '已发布任务数',
          link: '/butler/' + this.dynamiclink + '/task?statuses=9',
          value: this.qa_task.published
        }]
      };
    }
  }),
  methods: {
    getStats: function getStats() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.prev = 1;
                res = void 0;

                if (!(_this.type === 'assigned')) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return fetchAssignDemandStatistic();

              case 6:
                res = _context.sent;
                _context.next = 12;
                break;

              case 9:
                _context.next = 11;
                return fetchDemandStatistic();

              case 11:
                res = _context.sent;

              case 12:
                _this.demand = _Object$assign(_this.demand, _.get(res, 'data.data.demand'));
                _this.qa_task = _Object$assign(_this.qa_task, _.get(res, 'data.data.qa_task'));
                _this.loading = false;
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](1);

                _this.loading = false;

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 17]]);
      }))();
    }
  },
  mounted: function mounted() {
    this.getStats();
  }
};